export function getApiErrorMessage(error: any, fallback: string): string {
  const body = error?.error;
  const validationErrors = body?.errors;

  if (validationErrors && typeof validationErrors === 'object') {
    const messages = Object.values(validationErrors)
      .flatMap(value => Array.isArray(value) ? value : [value])
      .filter((value): value is string => typeof value === 'string' && value.trim().length > 0);

    if (messages.length > 0) {
      return messages.join(' ');
    }
  }

  if (typeof body?.detail === 'string' && body.detail.trim()) {
    return body.detail;
  }

  if (typeof body?.title === 'string' && body.title.trim()) {
    return body.title;
  }

  return fallback;
}
